import { z } from 'zod'
import { ThreadReactionSummarySchema, ThreadUserSchema, ReactionGroupSchema } from '../thread'
import { ThreadReactionSummary, ReactionGroup } from '../thread-reaction'
import { User } from '../user'

// Thread Comment sort field enum
export enum ThreadCommentSortFieldEnum {  
  CREATED_AT = 'createdAt',
  SEQUENCE = 'sequence',
}

export enum ThreadCommentHistoryAction {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}

/**
 * Interface representing a ThreadComment entity
 */
export interface ThreadComment {
  id: string;
  _eventId?: string;
  content: string;
  createdAt: Date;
  updatedAt?: Date;
  editedAt?: Date | null;
  deletedAt?: Date | null;
  threadId: string;
  organizationId: string;
  authorId: string;
  parentCommentId?: string | null;
  clientMessageId?: string | null;
  sequence: number;
  
  // Related entities
  author: Partial<User>;
  
  // Additional computed properties
  userReaction: ThreadReactionSummary | null;
  reactionGroups?: ReactionGroup[]; // Slack-style grouped reactions
  totalReactions: number;
  totalReplies: number;
  attachmentCount: number;
  hasAttachments: boolean;
}

export interface ThreadCommentHistory {
  id: string;
  commentId: string;
  threadId: string;
  editorId: string;
  action: ThreadCommentHistoryAction;
  previousContent?: string | null;
  newContent?: string | null;
  createdAt: Date;
  editor?: Partial<User>;
}

export interface ThreadCommentChangesMeta {
  lastCommentSequence: number;
  hasMore: boolean;
  serverTime: Date;
}

export interface ThreadCommentChangesResponse {
  data: ThreadComment[];
  meta: ThreadCommentChangesMeta;
}

// Create Thread Comment schema
export const CreateThreadCommentSchema = z.object({
  threadId: z.string().uuid(),
  parentCommentId: z.string().uuid().nullable(),
  content: z.string(),
  clientMessageId: z.string().uuid().nullable().optional(),
})

export type CreateThreadComment = z.infer<typeof CreateThreadCommentSchema>
